// src/components/Header.js
import React, { useEffect, useState } from "react";
import Logo from "../assets/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/reducer/authSlice";
import Avatar from "react-avatar";
import { useNavigate } from "react-router-dom";
const Header = ({ onLogout }) => {
  const { role, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-brand">
          <a href="/" className="logo-link">
            <img
              src={Logo}
              alt="Seth White Production Logo"
              className="header-logo"
            />
          </a>
        </div>
        <div className="mobile">
          <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>
          {user && (
            <Avatar
              style={{ cursor: "pointer" }}
              name={user?.name}
              size="36"
              round={true}
              onClick={() => {
                if (role === "admin") {
                  navigate("/dashboard/admin");
                } else if (role === "teacher") {
                  navigate("/dashboard/teacher");
                } else {
                  navigate("/dashboard/student");
                }
              }}
            />
          )}
        </div>

        <nav className={`header-nav ${menuOpen ? "active" : ""}`}>
          <a href="/" className="nav-link">
            Home
          </a>
          <a href="/About" className="nav-link">
            About us
          </a>
          <a href="/contact" className="nav-link">
            Contact
          </a>
          <a href="/membership" className="nav-link">
            Member Ship
          </a>
          {width <= "768" && (
            <div className="header-actions">
              {user ? (
                <button
                  onClick={() => dispatch(logout())}
                  className="btn btn-secondary "
                >
                  Logout
                </button>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "20px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <a href="/student-registration" className="btn btn-1">
                    Student Register
                  </a>
                  <a
                    href="https://mail.google.com/mail/?view=cm&to=admin@sethwhiteproductions.com"
                    target="_blank"
                    className="btn signupbtn"
                  >
                    Email Us to Become Teacher
                  </a>
                </div>
              )}
            </div>
          )}
        </nav>
        {width > "768" && (
          <div className="header-actions">
            {user ? (
              <>
                <Avatar
                  style={{ cursor: "pointer" }}
                  name={user.name}
                  size="36"
                  round={true}
                  onClick={() => {
                    if (role === "admin") {
                      navigate("/dashboard/admin");
                    } else if (role === "teacher") {
                      navigate("/dashboard/teacher");
                    } else {
                      navigate("/dashboard/student");
                    }
                  }}
                />
                <button
                  onClick={() => dispatch(logout())}
                  className="btn btn-secondary"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <a href="/student-registration" className="btn btn-1">
                  Student Register
                </a>
                <a
                  href="https://mail.google.com/mail/?view=cm&to=admin@sethwhiteproductions.com"
                  target="_blank"
                  className="btn signupbtn"
                >
                  Email Us to Become Teacher
                </a>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
